module.exports = __webpack_public_path__ + "x1.no1.9700b379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/x1.no1.jpg
// module id = mjIF
// module chunks = 0